// extracted by mini-css-extract-plugin
export default {"container":"CriteriaComment__container___yp9IC"};